function NavigationButton ( { onClick, image, label } ) 
{
    return <button className="block bg-transparent text-pgwhite flex flex-col items-center gap-2 p-2 w-1/4 sm:w-1/6" onClick={ () => onClick ()}>
                <img src={image} className="h-8 w-8" />
                <span className="text-xs text-nowrap">{label}</span>
            </button> 
}

export default NavigationButton;
